import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const OrderConfirmationModal = ({ isOpen, onClose, data }) => {
    const { t } = useLanguage();
    if (!isOpen) return null;

    const shortId = data?.id ? data.id.substring(0, 8).toUpperCase() : null;

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white rounded-lg shadow-2xl p-8 max-w-sm w-full text-center space-y-4 animate-in fade-in zoom-in duration-300" onClick={e => e.stopPropagation()}>
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-800">{t('orderPlacedTitle')}</h2>
                <p className="text-gray-600">{t('thankYouForShopping')}</p>
                
                {shortId && (
                    <div className="py-2 px-3 bg-stone-50 rounded border border-stone-200">
                        <span className="text-xs text-gray-500 uppercase tracking-wider block">Order ID</span>
                        <span className="text-sm font-mono font-bold text-[#8B6939]">#{shortId}</span>
                    </div>
                )}

                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <p className="text-sm text-gray-800 font-medium">
                        {t('checkEmailForInvoice')}
                    </p>
                </div>

                <button onClick={onClose} className="w-full py-3 bg-[#b08d57] text-white font-bold rounded-lg hover:bg-[#9c7b4d] transition-all">
                    {t('continueShopping')}
                </button>
            </div>
        </div>
    );
};

export default OrderConfirmationModal;
